// extracted by mini-css-extract-plugin
export default {"link":"go-back_link__Yl1eS","arrowBack":"go-back_arrowBack__ENV2r"};